import { render, staticRenderFns } from "./IconChipOutline.vue?vue&type=template&id=d9fb6e74"
import script from "./IconChipOutline.vue?vue&type=script&lang=js"
export * from "./IconChipOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports